// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:is(.dialog-syzkaller, .dialog-conditions, .dialog-edge-selection) {
    color: #f08d49;
    padding: 2px;
    background: hsla(24, 20%, 20%, 1);
    box-shadow: 0 0 0.5em #999;
    width: min-content;
    min-width: 20vw;
    overflow: auto;
    font-size: small;
    h3 {
        text-align: center;
    }
    code {
        display: block;
        white-space: pre-wrap;
        padding: 5px;
        margin: 2px;
        background: #222;
        color: #ccc;
    }
    a {
        color: white;
    }
    input, button {
        color: #f08d49;
        background: hsla(24, 20%, 50%, 0.4);
    }

    &::backdrop {
        background: #22222280;
    }
}`, "",{"version":3,"sources":["webpack://./src/views/dialog/dialog.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,YAAY;IACZ,iCAAiC;IACjC,0BAA0B;IAC1B,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB;QACI,kBAAkB;IACtB;IACA;QACI,cAAc;QACd,qBAAqB;QACrB,YAAY;QACZ,WAAW;QACX,gBAAgB;QAChB,WAAW;IACf;IACA;QACI,YAAY;IAChB;IACA;QACI,cAAc;QACd,mCAAmC;IACvC;;IAEA;QACI,qBAAqB;IACzB;AACJ","sourcesContent":[":is(.dialog-syzkaller, .dialog-conditions, .dialog-edge-selection) {\n    color: #f08d49;\n    padding: 2px;\n    background: hsla(24, 20%, 20%, 1);\n    box-shadow: 0 0 0.5em #999;\n    width: min-content;\n    min-width: 20vw;\n    overflow: auto;\n    font-size: small;\n    h3 {\n        text-align: center;\n    }\n    code {\n        display: block;\n        white-space: pre-wrap;\n        padding: 5px;\n        margin: 2px;\n        background: #222;\n        color: #ccc;\n    }\n    a {\n        color: white;\n    }\n    input, button {\n        color: #f08d49;\n        background: hsla(24, 20%, 50%, 0.4);\n    }\n\n    &::backdrop {\n        background: #22222280;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
